import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import "./ContractForm.css";
import EditForm from "./EditForm";
import apiClient from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

export default function EditContactForm() {
    const [showCustomURLInput, setShowCustomURLInput] = useState(true);
    const navigate = useNavigate();
    const childStateRef = useRef();
    const title = useSelector((state) => state.title.title);
    const {Id} = useParams();
    const isEdit = !!Id;
    const [loadedQuestions, setLoadedQuestions] = useState([]);


  const handleRadioChange = (event) => {
    setShowCustomURLInput(event.target.value === "custom");
  };

  const [expanded, setExpanded] = useState(false);

  const toggleSidebar = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (isEdit) {
      apiClient.get(`/ShowInEdit/${Id}`).then(res => {
        const data = res.data;
        //setTitle(data.title);
        const normalizedQuestions = data.questions.map(q => ({
          ...q,
          option: Array.isArray(q.options)
            ? q.options
            : Array.isArray(q.option)
            ? q.option
            : [],
        }));
        setLoadedQuestions(res.data.questions || []);
        // send data to child Form component
        childStateRef.current.setQuestion(normalizedQuestions);
      })
      .catch(err => {
        console.error(err);
      });
    }
  },[Id]);


  useEffect(() => {
  if (loadedQuestions.length > 0 && childStateRef.current) {
    childStateRef.current.setQuestion(loadedQuestions);
  }
}, [loadedQuestions]);


      useEffect(() => {
        const handlePublish = () => {
          handleSubmit(); // your edit API function
        };

        window.addEventListener("publishContactForm", handlePublish);

        return () => {
          window.removeEventListener("publishContactForm", handlePublish);
        };
      }, []);


    const handleSubmit = async () => {
      const questionstate = childStateRef.current.getQuestion();
      const Title_2 = title;
      const placeholder_2 = childStateRef.current.getPlaceholder2();

      if (!title.trim()) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Form title is required",
        });
        return;
      }

      const payload = {
        user_id: JSON.parse(localStorage.getItem('user')).user.id,
        title: Title_2,
        placeholder: placeholder_2,
        email_to: JSON.parse(localStorage.getItem('user')).user.email,
        questions: questionstate.map((tab) => ({
          type: tab.type,
          showServiceInfo: tab.showServiceInfo,
          ques: tab.ques,
          ques2: tab.ques2,
          placeholder: tab.placeholder,
          placeholder2: tab.placeholder2,
          options: tab.option,
          optionadd: tab.optionadd,
        })),
      };

      try {

        if (isEdit) {
          const response = await apiClient.put(
            `/contactFormEdit/${Id}`,
            payload
          );

            const slug = response.data.data.slug;
            const title = response.data.data.title;
            const completeUrl = `${window.location.origin}/showContactForm/${slug}`;
            const embedCode = `<iframe src="https://app.eventtrackit.com/showContactForm/${slug}" frameborder="0" width="600" height="400"></iframe>`;


          window.dispatchEvent(
            new CustomEvent("contactFormSaved", {
              detail: { slug, title, completeUrl, embedCode }
            })
          );

        } else {

          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Form Didn't Updated successfully!",
          });
        }

        //navigate("/contact-form");

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: getErrorMessage(error),
        });
      }
    };

  return (
    <>
      <div className='container-fluid p-lg-0 py-lg-3 p-md-5 p-3'>
        <div className='row g-lg-5 g-md-5 g-3 px-lg-5' style={{justifyContent: "center"}}>
          {/*begin: Main form area */}
          <div className='col-md-8'>
            <div className='form_container'>
              <EditForm ref={childStateRef} />
            </div>
          </div>
          {/*end: Main form area */}
          {/*begin: Sidebar area 
          <div className='col-lg-4'>
            <div
              className={`side_bar_contract_form shadow  ${
                expanded ? "aside-menu--expanded" : ""
              }`}>
              <div className='sidebar_header'>
                {!expanded ? (
                  <button
                    type='button'
                    className='mt-3 ms-4 text-black hamburger_side'
                    onClick={toggleSidebar}>
                    <i className='fas fa-times'></i>
                  </button>
                ) : (
                  <button
                    type='button'
                    className='mt-3 ms-4 text-black hamburger_side hamburger_side_mobile'
                    onClick={toggleSidebar}>
                    <i className='fas fa-bars hamburger_side_icon'></i>
                  </button>
                )}
                <h5
                  className={`mb-2 ${
                    expanded ? "aside-menu--expanded-body-content" : ""
                  }`}>
                  Setting
                </h5>
              </div>
              <div
                className={`sidebar_content_body px-2 ${
                  expanded ? "aside-menu--expanded-body-content" : ""
                }`}>
                <div className='form_sidebar'>
                  <div className='sidebar_main'>
                    <div className='sidebar-content'>
                      Form Name / Title 
                      <div className='link_input'>
                              <input
                                type='text'
                                placeholder='Please Enter Form Name'
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                              />
                      </div>
                      <h5 className='mb-3'>
                        After Form Complication Redirect To
                      </h5>
                      <div className='form_group position-relative'>
                        <div className='form-check mb-2'>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='redirectOption'
                            id='flexRadioDefault1'
                            value='default'
                            onChange={handleRadioChange}
                            defaultChecked
                          />
                          <div>
                            <label
                              className='form-check-label form-check-label_sidebar label_tooltip'
                              htmlFor='flexRadioDefault1'>
                              Default Thank You Message
                              <span className='ques_arrow'>
                                <i className='fa-solid fa-question'></i>
                              </span>
                            </label>
                            <div className='toolTipContent d-none'>
                              <span>
                                When your client submits a form, well show a
                                default Thank You message to confirm receipt
                              </span>
                              <div className='arrowForm'></div>
                            </div>
                          </div>
                        </div>
                        <div className='form-check'>
                          <input
                            className='form-check-input'
                            type='radio'
                            name='redirectOption'
                            id='flexRadioDefault2'
                            value='custom'
                            onChange={handleRadioChange}
                          />
                          <label
                            className='form-check-label form-check-label_sidebar'
                            htmlFor='flexRadioDefault2'>
                            Your Own Custom URL
                          </label>

                          {showCustomURLInput && (
                            <div className='link_input'>
                              <input
                                type='text'
                                placeholder='https://mywebsite.com/thanks'
                              />
                            </div>
                          )}
                        </div>
                      </div> 
                    </div>
                    <div className='text-center pt-2'>
                      <button
                        id='submit-btn'
                        type='button'
                        className='px-5 rounded-pill btn btn-primary btn-lg text-uppercase'
                        onClick={handleSubmit}
                        >
                        Save
                      </button>
                    </div>
                    <div className='sidebar-bottom'>
                      <h5 className='mb-3'>SPAM PROTECTION</h5>
                      <p>
                        ET Web App uses Google as your Contact Form Spam
                        Protection
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*end: Sidebar area */}
        </div>
      </div>
    </>
  );
}
